import React from "react";
import type { LucideIcon } from "lucide-react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "../../lib/cn";

const icon = cva("shrink-0", {
  variants: {
    size: {
      sm: "h-4 w-4",
      base: "h-5 w-5",
      lg: "h-6 w-6",
    },
  },
  defaultVariants: { size: "base" },
});

type IconProps = React.SVGAttributes<SVGSVGElement> &
  VariantProps<typeof icon> & {
    icon: LucideIcon;
  };

// Standardizes size + color-inherits-from-parent-text (`currentColor` is
// lucide-react's default stroke) so consumers never hand-tune icon dimensions.
export function Icon({ icon: IconComponent, size, className = "", ...props }: IconProps) {
  return <IconComponent className={cn(icon({ size }), className)} {...props} />;
}
